export default __webpack_public_path__ + "images/0x1b6382dbdea11d97f24495c9a90b7c88469134a4.png";